import { useState } from 'react'

/**
 * A figure that tints green or red for a moment when what it shows changes (Nov 4 2026, the market-list touch on
 * Coinbase). The comparison is on the printed text, so float noise under the displayed precision never flashes, and the
 * direction comes from the numbers. Each change remounts the span (its key), which replays the CSS animation
 * (.flash-up / .flash-down in index.css); nothing is timed in JS, and the first render never flashes.
 */
export function Flash({ value, text, className = '' }: { value: number | null | undefined; text: string; className?: string }) {
  const [seen, setSeen] = useState({ value, text })
  const [dir, setDir] = useState<'up' | 'down' | null>(null)
  if (text !== seen.text) {
    setSeen({ value, text })
    setDir(value != null && seen.value != null && value !== seen.value ? (value > seen.value ? 'up' : 'down') : null)
  }
  return (
    <span key={dir ? `${dir}:${text}` : 'still'} className={`-mx-1 rounded px-1 ${dir === 'up' ? 'flash-up' : dir === 'down' ? 'flash-down' : ''} ${className}`}>
      {text}
    </span>
  )
}
